import {AbstractControl, ValidationErrors, ValidatorFn} from '@angular/forms';

export function dateValidator(): ValidatorFn {
    return (control:AbstractControl) : ValidationErrors | null => {

        const value = control.value as Date;

        if (!value) {
            return null;
        }

        const now = new Date();
        const isInFuture = value > now;

        const isTooYoung = now.getFullYear() - value.getFullYear() < 14 ;
        const isValid = !isInFuture && !isTooYoung;

        return isValid ? null : {dateValidator: true};
    }
}
